export const Auth = btoa("Authorization");
export const AccountType = btoa("accountType");
export const Company = btoa("company");
export const Client = btoa("client");
export const Document = btoa("document");
export const DataReferencia = btoa("dataReferencia");
export const Provider = btoa("provider");
